import { Bounds, Position } from "../defines/types"
import { FLOOR_TILE, Tile, WALL_TILE } from "./tile"

export class Room {
  private _tiles: Tile[][] = []

  static fromTiles(x: number, y: number, tiles: Tile[][]): Room {
    if (tiles.length == 0 || tiles[0].length == 0) {
      throw new Error("Invalid tileset for creating Room instance")
    }

    let room = new this(x, y, tiles[0].length, tiles.length)
    room._tiles = tiles
    return room
  }

  constructor(
    public x: number,
    public y: number,
    public width: number,
    public height: number,
    public label?: string
  ) {
    this.buildRoom()
  }

  get bounds(): Bounds {
    return {
      x1: this.x,
      y1: this.y,
      x2: this.x + this.width,
      y2: this.y + this.height,
    }
  }

  buildRoom() {
    this._tiles = new Array(this.height)
    for (let y = 0; y < this.height; y++) {
      const row = new Array(this.width)
      for (let x = 0; x < this.width; x++) {
        const isWall =
          x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1
        row[x] = isWall ? { ...WALL_TILE } : { ...FLOOR_TILE }
      }
      this._tiles[y] = row
    }
  }

  intersects(other: Room): boolean {
    return (
      this.x <= other.x + other.width &&
      this.x + this.width >= other.x &&
      this.y <= other.y + other.height &&
      this.y + this.width >= other.y
    )
  }

  public get center(): Position {
    const x = this.x + Math.floor(this.width / 2)
    const y = this.y + Math.floor(this.height / 2)
    return { x: x, y: y }
  }

  public get topCenter(): Position {
    const x = this.x + Math.floor(this.width / 2)
    const y = this.y
    return { x: x, y: y }
  }

  public get rightCenter(): Position {
    const x = this.x + this.width - 1
    const y = this.y + Math.floor(this.height / 2)
    return { x: x, y: y }
  }

  public get bottomCenter(): Position {
    const x = this.x + Math.floor(this.width / 2)
    const y = this.y + this.height - 1
    return { x: x, y: y }
  }

  public get leftCenter(): Position {
    const x = this.x
    const y = this.y + Math.floor(this.height / 2)
    return { x: x, y: y }
  }

  public get tiles(): Tile[][] {
    return this._tiles
  }
}
